import { Box, lighten, Typography, useTheme } from '@mui/material';
import { FC } from 'react';
import { FaUser } from 'react-icons/fa';

const UserName: FC<React.PropsWithChildren<UserNameProps>> = ({ name }) => {
  const theme = useTheme();

  return (
    <Box display='flex' alignItems='center' gap={1}>
      <FaUser
        style={{
          width: '1rem',
          height: '1rem',
          fill: lighten(theme.palette.primary.main, 0.5),
        }}
      />
      <Typography
        variant='body2'
        color='textPrimary'
        sx={{ textTransform: 'capitalize' }}>
        {name}
      </Typography>
    </Box>
  );
};

export interface UserNameProps {
  name: string;
}

export default UserName;
